import { useState } from "react";
import { toast } from "sonner";
import { importarExcel } from "./api";

export default function ImportExcelTab() {
  const [archivo, setArchivo] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setArchivo(f);
    setPreview(null);
  };

  const generarPreview = async () => {
    if (!archivo) return toast.error("Selecciona un archivo .xlsx");
    setLoading(true);
    try {
      const data = await importarExcel(archivo, true);
      setPreview(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error al leer el Excel");
    } finally { setLoading(false); }
  };

  const confirmar = async () => {
    if (!archivo || !preview) return;
    setLoading(true);
    try {
      const data = await importarExcel(archivo, false);
      toast.success(`Importados: ${data.importadas} · Omitidos (duplicados): ${data.duplicadas_omitidas}`);
      setArchivo(null);
      setPreview(null);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error al importar");
    } finally { setLoading(false); }
  };

  return (
    <div className="via-card" data-testid="vial-import-excel">
      <h2><i className="fa-solid fa-file-excel"/> Importar Excel · CRC / Oficios</h2>
      <div className="via-form-row">
        <label>Archivo del portal CRC (.xlsx)</label>
        <input type="file" accept=".xlsx,.xls" onChange={onFile} data-testid="vial-import-file"/>
        <span className="hint">El sistema detecta automáticamente las columnas (folio, ubicación, GPS, colonia, etc.).</span>
      </div>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <button className="via-btn-ghost" disabled={!archivo || loading} onClick={generarPreview} data-testid="vial-import-preview">
          {loading && !preview ? "Leyendo…" : "Vista previa"}
        </button>
        {preview && (
          <button className="via-btn" disabled={loading || preview.importadas === 0 && preview.total_filas - preview.duplicadas_omitidas === 0} onClick={confirmar} data-testid="vial-import-confirm">
            {loading ? "Importando…" : `Confirmar importación (${(preview.total_filas || 0) - (preview.duplicadas_omitidas || 0)} filas)`}
          </button>
        )}
      </div>

      {preview && (
        <div style={{ marginTop: 16 }}>
          <div className="via-grid-stats">
            <div className="via-stat"><div className="lbl">Total filas</div><div className="val">{preview.total_filas}</div></div>
            <div className="via-stat"><div className="lbl">Duplicados</div><div className="val" style={{ color: "#D97706" }}>{preview.duplicadas_omitidas}</div></div>
            <div className="via-stat"><div className="lbl">Sin GPS</div><div className="val" style={{ color: "#DC2626" }}>{preview.sin_gps}</div></div>
            <div className="via-stat"><div className="lbl">Listos para importar</div><div className="val" style={{ color: "#16A34A" }}>{Math.max(0, (preview.total_filas || 0) - (preview.duplicadas_omitidas || 0))}</div></div>
          </div>

          <details style={{ marginBottom: 10 }}>
            <summary style={{ cursor: "pointer", fontWeight: 700, fontSize: 13 }}>
              Columnas detectadas ({Object.keys(preview.mapeo_columnas || {}).length} mapeadas)
            </summary>
            <div style={{ fontSize: 12, color: "#64748B", padding: "6px 0" }}>
              {Object.entries(preview.mapeo_columnas || {}).map(([k, v]) => (
                <div key={k}><strong>{k}</strong> ← {v}</div>
              ))}
              {(preview.headers_detectados || []).length > 0 && (
                <div style={{ marginTop: 6 }}><em>Otros encabezados ignorados:</em> {(preview.headers_detectados || []).filter(h => !Object.values(preview.mapeo_columnas || {}).includes(h)).join(" · ") || "—"}</div>
              )}
            </div>
          </details>

          <div style={{ overflowX: "auto" }}>
            <table className="via-tabla" data-testid="vial-import-tabla">
              <thead><tr><th>Folio</th><th>Ubicación</th><th>Colonia</th><th>GPS</th><th>Estado</th></tr></thead>
              <tbody>
                {(preview.preview || []).map((f, i) => (
                  <tr key={i} style={{ background: f.duplicado ? "#FEF3C7" : f.gps_estado !== "OK" ? "#FEE2E2" : "transparent" }}>
                    <td>{f.folio}</td>
                    <td>{f.ubicacion || "—"}</td>
                    <td>{f.colonia || "—"}</td>
                    <td style={{ fontSize: 11, fontFamily: "monospace" }}>
                      {f.lat != null && f.lng != null ? `${Number(f.lat).toFixed(4)}, ${Number(f.lng).toFixed(4)}` : "—"}
                    </td>
                    <td>
                      {f.duplicado && <span className="via-badge via-badge-poli">DUPLICADO</span>}
                      {!f.duplicado && f.gps_estado === "OK" && <span className="via-badge via-badge-completado">OK</span>}
                      {!f.duplicado && f.gps_estado !== "OK" && <span className="via-badge via-badge-cancelado">{f.gps_estado}</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
